import React, { useState, useEffect } from "react";
import { LookupUserDTOV1, OrganizationDTO, UserDetailsDTO } from "@beable/roster-backend-client-v1";
import dataViewService from "../../../services/DataViewService";
import UserDetails from "../../DataView/UserDetails";
import { Box } from "@mui/material";
import { uniqBy } from 'lodash';

interface UserRosterDataProps {
    user: LookupUserDTOV1;
  }
  
  export default function UserRosterData({
    user
  }: UserRosterDataProps) {
    const [userDetails, setUserDetails] = useState<UserDetailsDTO | null>();
    const [userOrgs, setUserOrgs] = useState<OrganizationDTO[]>([]);

    useEffect(() => {
        const fetchUserData = async () => {
          if (user) {
            const fetchedUserDetails = await dataViewService.getUserDetails(user.userId);
            setUserDetails(fetchedUserDetails);

            const fetchUserOrgs = await dataViewService.findUserOrgs(user.siteId, user.userId);
            if (fetchUserOrgs) {
              setUserOrgs(uniqBy(fetchUserOrgs.orgs, 'id'));
            }
          }
        };
        fetchUserData();
      }, [user]);
    

    return (
        <Box sx={{ padding: 10 }}>
            <UserDetails 
              userDetails={userDetails!} 
              orgs={userOrgs} 
              isLoading={false} 
            />
        </Box>
    )
  }  